module.exports = __webpack_public_path__ + "img/waves-5.19f9f412.webp";